// components/project-details/ProjectStatusBadge.js
import React from 'react';
import styles from './ProjectDetails.module.css';

const ProjectStatusBadge = ({ status }) => {
  const getStatusLabel = (status) => {
    switch (status) {
      case 'new_enquiry':
        return 'New Enquiry';
      case 'in_conversation':
        return 'In Conversation';
      case 'project_started':
        return 'Active Project';
      case 'project_completed':
        return 'Completed';
      case 'archived':
        return 'Archived';
      default:
        return status;
    }
  };

  return (
    <span className={`${styles.statusBadge} ${styles[status]}`}>
      {status === 'new_enquiry' && (
        <span className={`${styles.pulsingDot} ${styles.new}`}></span>
      )}
      {status === 'project_started' && (
        <span className={`${styles.pulsingDot} ${styles.active}`}></span>
      )}
      {getStatusLabel(status)}
    </span>
  );
};

export default ProjectStatusBadge;